import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { filter, interval } from 'rxjs';
import { APP_ENV } from '../app-environment';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private readonly env = inject(APP_ENV);
  private readonly swUpdate = inject(SwUpdate, { optional: true });

  constructor() {
    if (!this.swUpdate || !this.swUpdate.isEnabled || !this.env.production) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter((event: VersionEvent): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        void this.activateAndReload();
      });

    void this.swUpdate.checkForUpdate();
    interval(60 * 60 * 1000).subscribe(() => {
      void this.swUpdate?.checkForUpdate();
    });
  }

  private async activateAndReload() {
    try {
      await this.swUpdate?.activateUpdate();
      document.location.reload();
    } catch (error) {
      console.error('Failed to activate the latest application version', error);
    }
  }
}
